import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'


function RTISection4AdministrationEle6Pg() {
    return(
        <>
            
                <div className='container'>
                            <div className='ms-3'>
                                <h4>Budget and Programme</h4>
                            
                                <table className="table table-striped">
                                
<thead>
<tr>
<td >
<strong>S. No.</strong>
</td>
<td >
<strong>Item</strong>
</td>
<td >
<strong>Details</strong>
</td>
</tr>
  </thead>
  <tbody>
<tr>
<td>
<strong>2.1</strong>
</td>
<td colspan="2">
<strong>Budget allocated to each agency including all plans, proposed expenditure and reports on disbursements made etc. [Section 4(1)(b)(xi)]</strong>
</td>
</tr>
<tr>
<td>
2.1.1
</td>
<td>
Total Budget for the public authority
</td>
<td>

  The Budget Allocation for IIT Tirupati for the financial year 2025-26 is Rs.284.73 Crores 
</td>
</tr>
<tr>
<td>
2.1.2
</td>
<td>
Budget for each agency and plan &amp; programmes
</td>
<td>

 <strong>Budget Estimates-2025-26(in crores)</strong>
<table className="rti">
<tbody>
<tr>
<td>
OH-31
</td>
<td>
OH-35
</td>
<td>
OH-36
</td>
<td>
Total
</td>
</tr>
<tr>
<td>
50.00
</td>
<td>
273.44
</td>
<td>
79.78
</td>
<td>
403.22
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td>
2.1.3
</td>
<td>
Proposed expenditures
</td>
<td>

  
  <strong>Expenditure -2025-26(in crores)</strong>
<table className="rti">
<tbody>
<tr>
<td>
OH-31
</td>
<td>
OH-35
</td>
<td>
OH-36
</td>
<td>
Total
</td>
</tr>
<tr>
<td>
50.53
</td>
<td>
182.91
</td>
<td>
66.31
</td>
<td>
299.76
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td>
2.1.4
</td>
<td>
Revised budget for each agency, if any
</td>
<td>

  
  <strong>Revised Estimate -2025-26(in crores)</strong>
<table className="rti">
<tbody>
<tr>
<td>
OH-31
</td>
<td>
OH-35
</td>
<td>
OH-36
</td>
<td>
Total
</td>
</tr>
<tr>
<td>
43.47
</td>
<td>
182.91
</td>
<td>
58.35
</td>
<td>
284.73
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td>
2.1.5
</td>
<td>
Report on disbursement made and place where the related reports are available
</td>
<td>
The Registrar, IIT Tirupati
</td>
</tr>
<tr>
<td>
<strong>2.2</strong>
</td>
<td colspan="2">
<strong>Foreign and domestic tours (F.No.1/8/2012-IR dt. 11.9.2012)</strong>
</td>
</tr>
<tr>
<td>
2.2.1
</td>
<td>
Budget
</td>
<td>
1. International tour Rs. 26.32 Lakhs<br />
2. Domestic tours Rs. 53.77 Lakhs
</td>
</tr>
<tr>
<td>
2.2.2
</td>
<td>
Foreign and domestic Tours by ministries and officials of the rank of Joint Secretary to the Government and above, as well as the heads of the Department.<br />
a) Places visited<br />
b) The period of visit<br />
c) The number of members in the official delegation<br />
d) Expenditure on the visit
</td>
<td>
International tour Rs. 26.32 lakhs and Domestic tour expenditure for the FY 2025-26 is Rs. 53.77 lakhs
</td>
</tr>
<tr>
<td>
2.2.3
</td>
<td>
Information related to procurements<br />
a) Notice/tender enquires, and corrigenda if any thereon,<br />
b) Details of the bids awarded
comprising the names of the suppliers of goods / services being procured,<br />
c) The works contracts concluded – in any such combination of the above and<br />
d) The rate / rates and the total amount at which such procurement or works contract is to be executed.
</td>
<td>
IIT Tirupati website: <a className="c-link" href="https://iittp.ac.in/tenders">https://iittp.ac.in/tenders</a><br />
Central Public Procurement Portal
Indian Institute of Technology Tirupati<br />
<p >Active Tenders: <a className="c-link" href="https://eprocure.gov.in/eprocure/app?page=FrontEndTendersByOrganisation&amp;service=page">https://eprocure.gov.in/eprocure/app?page=FrontEndTendersByOrganisation&amp;service=page</a><br />
</p><p >Tender Status: <a className="c-link" href="https://eprocure.gov.in/eprocure/app?page=WebTenderStatusLists&amp;service=page">https://eprocure.gov.in/eprocure/app?page=WebTenderStatusLists&amp;service=page</a>&nbsp;<br />
</p><p >Finalized Tenders: <a className="c-link" href="https://eprocure.gov.in/eprocure/app?page=ResultOfTenders&amp;service=page">https://eprocure.gov.in/eprocure/app?page=ResultOfTenders&amp;service=page</a><br />
</p><p >Archived Tenders: <a className="c-link" href="https://eprocure.gov.in/eprocure/app?page=FrontEndTendersInArchive&amp;service=page">https://eprocure.gov.in/eprocure/app?page=FrontEndTendersInArchive&amp;service=page</a>
</p></td>
</tr>
<tr>
<td>
<strong>2.3</strong>
</td>
<td colspan="2">
<strong>Manner of execution of subsidy programme [Section 4(i)(b)(xii)]</strong>
</td>
</tr>
<tr>
<td>
2.3.1
</td>
<td>
Name of the programme of activity
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
2.3.2
</td>
<td>
Objective of the programme
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
2.3.3
</td>
<td>
Procedure to avail benefits
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
2.3.4
</td>
<td>
Duration of the programme/ scheme
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
2.3.5
</td>
<td>
Physical and financial targets of the programme
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
2.3.6
</td>
<td>
Nature / scale of subsidy / amount allotted
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
2.3.7
</td>
<td>
Eligibility criteria for grant of subsidy
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
2.3.8
</td>
<td>
Details of beneficiaries of subsidy programme (number, profile etc.)
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
<strong>2.4</strong>
</td>
<td colspan="2">
<strong>Discretionary and non-discretionary grants [F.No.1/6/2011-IR dt.15.04.2013]</strong>
</td>
</tr>
<tr>
<td>
2.4.1
</td>
<td>
Discretionary and non-discretionary Grants / allocations to State Govt./
NGOs / other institutions&nbsp;
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
2.4.2
</td>
<td>
Annual accounts of all legal entities who are provided grants by public authorities
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
<strong>2.5</strong>
</td>
<td colspan="2">
<strong>Particulars of recipients of concessions, permits of authorizations granted by the public authority [Section 4(1)(b)(xiii)]</strong>
</td>
</tr>
<tr>
<td>
2.5.1
</td>
<td>
Concessions, permits or authorizations granted by public authority
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
2.5.2
</td>
<td>
For each concession, permit or authorization granted - <br />(a) Eligibility
criteria,<br /> (b) Procedure for getting the concession/ grant and/ or permits of
  authorizations, <br />(c) Name and address of the recipients given concessions/
permits or authorizations, <br />(d) Date of award of concessions/ permits of
authorizations
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
<strong>2.6</strong>
</td>
<td colspan="2">
<strong>CAG &amp; PAC paras [F No.1/6/2011-IR dt.15.4.2013]</strong>
</td>
</tr>
<tr>
<td>
2.6.1
</td>
<td>
CAG and PAC paras and the action taken reports (ATRs) after these have been laid on the table of both houses of the parliament.&nbsp;
</td>
<td>
Not Applicable
</td>
</tr>
</tbody>
</table>             
                            </div>
                    </div> 
            
        </>
    );
}

export default RTISection4AdministrationEle6Pg;